import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
export function ContactPage() {
  const scrollToForm = () => {
    const formElement = document.getElementById('quote-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const categories = [{
    title: 'Wood Cabinet Doors',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/09/mission-natural-450x450.jpg'
  }, {
    title: 'MDF Cabinet Doors',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/taylar-2-3c02bc4-interwood-mobel-450x450.jpg'
  }, {
    title: 'Installation Accessories',
    image: 'https://cdn.magicpatterns.com/uploads/szDXp6VuaBmHm96ZSTfwkT/image.png'
  }, {
    title: 'Cabinet Accessories',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/wall-450x450.png'
  }, {
    title: 'Handles and Knobs',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/51wzzpgmH3L._AC_US1000_-450x450.jpg'
  }];
  return <Layout data-id="element-321">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden" data-id="element-322">
        <div className="absolute inset-0 z-0" data-id="element-323">
          <img src="https://cdn.magicpatterns.com/uploads/eEe9VsmrA3SeUKnX2GxCoz/image.png" alt="Quotes Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-324" />
          <div className="absolute inset-0 bg-black/20" data-id="element-325" />
        </div>

        {/* Top Right CTA Button */}
        <div className="absolute top-8 right-8 z-20 hidden md:block" data-id="element-326">
          <button onClick={scrollToForm} className="bg-[#6B0D24] text-white px-8 py-3 font-black uppercase tracking-widest text-xs hover:bg-[#5A0B1E] transition-colors shadow-xl" data-id="element-327">
            Get a Quote
          </button>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-328">
          Quotes
        </motion.h1>
      </section>

      {/* Intro Text Section */}
      <section className="py-16 px-6 bg-white" data-id="element-329">
        <div className="max-w-4xl mx-auto text-center" data-id="element-330">
          <p className="text-charcoal/80 leading-relaxed text-base md:text-lg font-medium" data-id="element-331">
            We do our best to make sure our customers get the best deal, with
            high quality of workmanship. We specialize in both cabinet refacing
            and cabinet refinishing. We repair, modify or replace the existing
            cabinet to meet modern standards. Our new cabinets are all solid
            wood and plywood. NO particle board.
          </p>
        </div>
      </section>

      {/* Category Grid Section */}
      <section className="pb-24 px-6 bg-white" data-id="element-332">
        <div className="max-w-7xl mx-auto" data-id="element-333">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-id="element-334">
            {categories.map((category, idx) => <Link key={idx} to="/products" className="block group" data-id="element-335">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex flex-col items-center text-center cursor-pointer" data-id="element-336">
                  <div className="aspect-square w-full overflow-hidden bg-[#F5F5F5] mb-6 border border-charcoal/5" data-id="element-337">
                    <img src={category.image} alt={category.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-338" />
                  </div>
                  <h3 className="text-xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-339">
                    {category.title}
                  </h3>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Content Section - Form and Map */}
      <section id="quote-form" className="py-20 px-6 bg-alabaster border-t border-charcoal/5" data-id="element-340">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-341">
          {/* Left Column: Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-342">
            <h2 className="text-4xl font-black text-[#6B0D24] mb-10" data-id="element-343">
              Get In Touch
            </h2>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-344">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-345">
                <input type="text" placeholder="First Name" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-346" />
                <input type="text" placeholder="Last Name" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-347" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-348">
                <input type="email" placeholder="Your Email" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-349" />
                <input type="tel" placeholder="Phone Number" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-350" />
              </div>

              <input type="text" placeholder="Address" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-351" />

              <textarea placeholder="Enter Your Message" rows={6} className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors resize-none" data-id="element-352"></textarea>

              <button className="bg-[#6B0D24] text-white px-12 py-4 font-black uppercase tracking-[0.2em] text-sm hover:bg-[#5A0B1E] transition-colors" data-id="element-353">
                Submit
              </button>
            </form>
          </motion.div>

          {/* Right Column: Map */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[500px] lg:h-[650px] w-full border border-charcoal/5 shadow-2xl overflow-hidden" data-id="element-354">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3098.375548052479!2d-76.6975!3d39.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7e9!2s1807%20Oriole%20Ct%2C%20Severn%2C%20MD%2021144!5e0!3m2!1sen!2sus!4v1716912000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="NK Resurfacers Location" data-id="element-355"></iframe>
          </motion.div>
        </div>
      </section>
    </Layout>;
}